import { createSlice } from '@reduxjs/toolkit';
import { isPlainObject } from 'lodash';
import { ApiRequestSucceed } from '../saga/api/actions';
import { TUnitsState } from '../types';

const COLLECTION_WHITELIST: Record<string, RegExp[]> = {
  units: [/^[\w\d\-_]+$/],
};

const unitsSlice = createSlice({
  name: 'units',
  initialState: {
    users: {},
    userCards: {},
  } as TUnitsState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(ApiRequestSucceed, (state, { payload }) => {
      if (!isPlainObject(payload.data)) return;

      const data = payload.data as Record<string, Record<string, unknown>>;
      const newUnits = data.units;
      if (!newUnits) return;

      const patterns = COLLECTION_WHITELIST.units;
      const filtered = Object.fromEntries(
        Object.entries(newUnits).filter(([key]) => patterns.some(re => re.test(key)))
      );

      const addition = payload.addition;

      for (const [collectionName, items] of Object.entries(filtered)) {
        if (!isPlainObject(items)) continue;

        const newCollection = items as Record<string, any>;

        // Инициализируем коллекцию, если её ещё нет
        if (!state[collectionName]) {
          state[collectionName] = {};
        }

        const existingCollection = state[collectionName] as Record<string, any>;

        for (const [itemId, newItem] of Object.entries(newCollection)) {
          if (!isPlainObject(newItem)) continue;

          if (addition && existingCollection[itemId]) {
            // Плоское слияние: новые атрибуты добавляются/обновляются в существующем экземпляре
            state[collectionName][itemId] = { ...existingCollection[itemId], ...newItem };
          } else {
            // Полная замена или добавление нового экземпляра
            state[collectionName][itemId] = newItem;
          }
        }
      }
    });
  },
});

export default unitsSlice.reducer;
